import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import axiosClient from '@/lib/axios';

import type { Package } from '../types';

type FetchPackagesParams = {
  companyID: number;
};

export const fetchPackages = async ({ companyID }: FetchPackagesParams): Promise<{ data: Package[] }> => {
  const { data } = await axiosClient.get<{ data: Package[] }>(`/premium/${companyID}/subscription/packages`);
  return data;
};

type UseGetPackagesOptions = {
  companyID: number;
  config?: Partial<UseQueryOptions<{ data: Package[] }>>;
};
export const useGetPackages = ({ companyID, config }: UseGetPackagesOptions) => {
  return useQuery({
    queryKey: ['packages'],
    queryFn: () => fetchPackages({ companyID }),
    ...config,
  });
};
